export default __webpack_public_path__ + "static/media/Deli_Check.11b92677.svg";